import { render, staticRenderFns } from "./ResponseList.vue?vue&type=template&id=37f78a82&"
import script from "./ResponseList.vue?vue&type=script&lang=js&"
export * from "./ResponseList.vue?vue&type=script&lang=js&"
import style0 from "./ResponseList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports